
import { ConferenceListItem } from "@gsx/common/src/types/http/dashboard/conference";
import { Container } from "inversify";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { AuthStore } from "../../../../common/src/stores/AuthStore";

@Component({
    components: {},
})
export default class CalendarEvent extends Vue {
    @Prop() conferenceListItem!: ConferenceListItem;
    @Inject("container") readonly container!: Container;
    authStore: AuthStore = this.container.get(AuthStore);

    // isEditModalVisible = false;
    // isViewModalVisible = false;

    // displayViewModal() {
    //     this.isViewModalVisible = true;
    // }

    // hideViewModal() {
    //     this.isViewModalVisible = false;
    // }

    // displayEditModal() {
    //     this.isEditModalVisible = true;
    // }

    // hideEditModal() {
    //     this.isEditModalVisible = false;
    // }
}
